/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Section_BehaviourInputs */

const vi_packaging_material_section_behaviour = /** @type {(inputs: Packaging_Material_Section_BehaviourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách kho xử lý`)
};

/**

* @param {Packaging_Material_Section_BehaviourInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_section_behaviour = /** @type {((inputs?: Packaging_Material_Section_BehaviourInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Section_BehaviourInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_section_behaviour(inputs)
});